module.exports = __webpack_public_path__ + "img/wash-hands.f4905442.svg";